import translations from './silver.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/silver'

export const silver: Metal = {
  id: 21,
  slug: 'silver',
  name: t.name,
  symbol: 'Ag',
  mines: [
    {
      name: "Fresnillo (Mexico, Fresnillo PLC, Zacatecas — world's largest primary silver mine)",
      region: 'Fresnillo',
      coordinates: [-102.87, 23.17],
    },
    {
      name: 'Peñasquito (Mexico, Newmont)',
      region: 'Peñasquito',
      coordinates: [-102.35, 23.9],
    },
    {
      name: 'Antamina (Peru)',
      region: 'Antamina',
      coordinates: [-77.06, -9.53],
    },
    {
      name: "Cerro Rico/Potosí (Bolivia — historically the world's richest silver deposit)",
      region: 'Cerro Rico/Potosí',
      coordinates: [-65.75, -19.58],
    },
    {
      name: 'Cannington (Australia, South32)',
      region: 'Cannington',
      coordinates: [140.27, -22.55],
    },
  ],
  countries: [
    { name: 'Mexico', percent: 25.2 },
    { name: 'China', percent: 13.2 },
    { name: 'Peru', percent: 12.4 },
    { name: 'Poland', percent: 5.2 },
    { name: 'Bolivia', percent: 5.2 },
  ],
  // Mostly recovered as a by-product of lead, zinc, copper or gold mining.
  related: ['lead', 'zinc', 'copper', 'gold'],
  content: {
    smartphone: {
      quantityScore: 2,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 3, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 1, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 4, ...t.supplyRisk },
    recycling: { score: 3, ...t.recycling },
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
      secondBento: [
        {
          src: `${dir}/03.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
